import { Token } from './tokens';

export type TokenMeta = {
  readonly range: readonly [number, number] | null;

  readonly comments: {
    leading: string[];
    trailing: string | null;
  };
};

export type WithMeta<T> = readonly [data: T, meta: TokenMeta];
export type WithRange<T> = readonly [data: T, meta: Pick<TokenMeta, 'range'>];
export type WithComments<T> = readonly [data: T, Pick<TokenMeta, 'comments'>];

/**
 * Any token that isn't whitespace or comment
 */
export type IntermediateToken = Exclude<
  Token,
  { t: 'whitespace' } | { t: 'comment' }
>;

// TODO look into
export function withNullMeta<T>(data: T): WithMeta<T> {
  return [data, { range: null, comments: { leading: [], trailing: null } }];
}
